<template>
  <div class="is-marginless is-paddingless section">
    <div class="entete">
      <div class="columns">
        <div class="column">
          <div class="title is-size-3">{{ getTitle }}</div>
          <app-breadcrumb :breadcrumb="breadcrumb"/>
        </div>
        <div class="column">
          <div class="is-pulled-right buttons boutonAction">
            <router-link :to="{ name: 'm.bodac.commandes-ajout'}">
              <a class="button is-addOrEdit"
              :class="{'button-access-no-permission' : !checkPermissions(permCommandes.maj)}">
                {{ $t('listeCommandes.actions.newQuotation')}}
              </a>
            </router-link>
          </div>
        </div>
      </div>
      <div class="tab is-marginless">
        <ul>
          <router-link :to="{ name: 'l.bodac.commandes-liste'}"
                       :class="{'text-access-no-permission':
                     !checkPermissions(permCommandes.lecture)}">
            <li :class="{'is-active': $router.currentRoute.name === 'l.bodac.commandes-liste'
            || $router.currentRoute.name === 'l.bodac.commandes-listeReferences'
            || $router.currentRoute.name === 'l.bodac.commandes-liste-par-parution'
            || $router.currentRoute.name === 'l.bodac.commandes-listeReferencesId'
            || $router.currentRoute.name === 'l.bodac.commandes-liste-par-produit'}">
              {{ $t('listeCommandes.tab.commandes') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'l.bodac.commandes-echeancesBonAFacturer'}"
                       :class="{'text-access-no-permission':
                     !checkPermissions(permCommandes.lecture)}"
                       v-if="societeActive.activerBonAFacturer">
            <li :class="{'is-active': $router.currentRoute.name
            === 'l.bodac.commandes-echeancesBonAFacturer'}">
              {{ $t('listeCommandes.tab.baf') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'l.bodac.commandes-aFacturer' }"
                       :class="{'text-access-no-permission':
                     !checkPermissions(permCommandes.lecture)}">
            <li :class="{'is-active': $router.currentRoute.name === 'l.bodac.commandes-aFacturer'
            || $router.currentRoute.name === 'l.bodac.commandes-aFacturer-par-parution'}">
              {{ $t('listeCommandes.tab.commandeAFacturer') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'l.bodac.commandes-echeances' }"
                       :class="{'text-access-no-permission':
                     !checkPermissions(permCommandes.lecture)}">
            <li :class="{'is-active': $router.currentRoute.name === 'l.bodac.commandes-echeances'
            || $router.currentRoute.name === 'l.bodac.commandes-echeances-par-parution'}">
              {{ $t('listeCommandes.tab.facturer') }}
            </li>
          </router-link>
          <router-link :to="{ name: 'l.bodac.commandes-renouvellement'}"
                       :class="{'text-access-no-permission':
                     !checkPermissions(permCommandes.lecture)}">
            <li :class="{
              'is-active': $router.currentRoute.name === 'l.bodac.commandes-renouvellement'
              }">
              {{ $t('listeCommandes.tab.renouvellement') }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { COMMANDES } from '@/configuration/permissionsBodacConf';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permCommandes: COMMANDES,
    };
  },
  components: {
    AppBreadcrumb,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    getTitle() {
      switch (this.$router.currentRoute.name) {
        case 'l.bodac.commandes-liste':
        case 'l.bodac.commandes-liste-par-produit':
        case 'l.bodac.commandes-listeReferencesId':
        case 'l.bodac.commandes-listeReferences':
          return this.$i18n.t('listeCommandes.titleCommande');
        case 'l.bodac.commandes-echeancesBonAFacturer':
          return this.$i18n.t('listeCommandes.titleCommandeBAF');
        case 'l.bodac.commandes-echeances':
          return this.$i18n.t('listeCommandes.titleEcheancesAFacturer');
        case 'l.bodac.commandes-aFacturer':
          return this.$i18n.t('listeCommandes.titleCommandeAFacturer');
        case 'l.bodac.commandes-aFacturer-par-parution':
          return this.$i18n.t('listeCommandes.titleCommandeAFacturer');
        default:
          return this.$i18n.t('listeCommandes.titleCommandeARenouveler');
      }
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeCommandes.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: { name: 'l.bodac.commandes-liste' }, isActive: true },
      ];
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.commande.listeCommande'));
  },
};

</script>
